import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiShoppingBag, FiFileText, FiChevronRight } from 'react-icons/fi';
import * as translator from '../../../../../utils/translator';
import { QuickLink } from 'data-types';



interface QuickLinksProps {
	quickLinks: QuickLink[];
	language: string;
	onOpenTreatmentDocuments?: () => void;
}

const iconByLinkKey: Record<string, React.ReactNode> = {
	'orders-subscription': <FiShoppingBag className="text-care-plus-orange" size={22} />,
	'treatment-documents': <FiFileText className="text-care-plus-orange" size={22} />,
};

const subtitleKeyByLinkKey: Record<string, string> = {
	'orders-subscription': 'CareProfile/QuickLinks/OrdersSubscriptionSubtitle',
	'treatment-documents': 'CareProfile/QuickLinks/TreatmentDocumentsSubtitle',
};

const QuickLinks: React.FC<QuickLinksProps> = ({ quickLinks, language, onOpenTreatmentDocuments }) => {
	const navigate = useNavigate();

	const handleClick = (link: QuickLink) => {
		if (link.key === 'treatment-documents' && onOpenTreatmentDocuments) {
			onOpenTreatmentDocuments();
		} else if (link.external) {
			window.location.href = link.path;
		} else {
			navigate(link.path);
		}
	};

	return (
		<div id="care-profile-quick-links" className="flex flex-col gap-y-3">
			{quickLinks.map((link) => (
				<button
					key={link.key}
					id={`care-profile-quick-link-${link.key}`}
					type="button"
					onClick={() => handleClick(link)}
					className="flex items-center gap-x-3 bg-white border-none rounded-[17px] p-3 text-left shadow-[0_0_0_1px_#e7e4db] cursor-pointer hover:shadow-md transition-shadow duration-200"
				>
					<span className="flex items-center justify-center w-[43px] h-[43px] rounded-[15px] bg-[#faf4ef] flex-shrink-0">{iconByLinkKey[link.key]}</span>
					<span className="flex-1 flex flex-col min-w-0">
						<span className="text-[15px] font-medium text-care-plus-heading truncate">{translator.translate(language, 'my_account', link.labelKey)}</span>
						{subtitleKeyByLinkKey[link.key] && (
							<span className="text-[13px] text-[#99a3b2] truncate">{translator.translate(language, 'my_account', subtitleKeyByLinkKey[link.key])}</span>
						)}
					</span>
					<FiChevronRight className="text-[#99a3b2] flex-shrink-0" size={22} />
				</button>
			))}
		</div>
	);
};

export default QuickLinks;
